/* eslint-disable no-unused-vars */
import {Action} from '../../actions';

export enum ExcessesActionType {
  FETCH_EXCESSES_LIST_PENDING = 'FETCH_EXCESSES_LIST_PENDING',
  FETCH_EXCESSES_LIST_FULFILLED = 'FETCH_EXCESSES_LIST_FULFILLED',
  FETCH_EXCESSES_LIST_REJECTED = 'FETCH_EXCESSES_LIST_REJECTED'
}

export interface FetchExcessesFulfilledPayload {
  Excesses: Excesses[];
}

export interface Excesses {
  productId: number;
  excesses: number[];
}

interface FetchExcessesAction {
  type: ExcessesActionType;
}

interface FetchExcessesFulfilledAction extends Action<FetchExcessesFulfilledPayload, ExcessesActionType> {
  type: ExcessesActionType;
  payload: FetchExcessesFulfilledPayload;
}

export type ExcessesActionTypes = FetchExcessesAction | FetchExcessesFulfilledAction;
